import { z } from "zod";
import { SUPPORTED_CARRIER_IDS } from "helpers/carriers";

export const Step3Schema = z
  .object({
    carrier: z
      .array(z.enum(SUPPORTED_CARRIER_IDS))
      .default([]),
    priorCancelled: z.boolean().optional(),
    cancellations12mo: z.boolean().optional(),
    uiiaIntermodal: z.boolean().optional(),
    filingsAlFederal: z.boolean().optional(),
    filingsAlState: z.boolean().optional(),
    dumpLoadsTarped: z.boolean().optional(),
    freeBoardSixInches: z.boolean().optional(),
    roadsideConstruction: z.boolean().optional(),
    oversizedShipments: z.boolean().optional(),
    brokerageAuthority: z.boolean().optional(),
    ownerOperators: z.boolean().optional(),
    interlineAgreement: z.boolean().optional(),
    interchangeAgreement: z.boolean().optional(),
    intermodalAgreement: z.boolean().optional(),
    leaseVehiclesTrailers: z.boolean().optional(),
    travelMexico: z.boolean().optional(),
    travelCanada: z.boolean().optional(),
    teamDrivers: z.boolean().optional(),
    guestPassengers: z.boolean().optional(),
    subsidiary: z.boolean().optional(),
    tripLeasingUnderAuthority: z.boolean().optional(),
    opsTowingRep: z.preprocess(
      (val) => (val === "" || val == null ? undefined : val),
      z.enum(["Y", "N"]).optional()
    ),
    corgiTravelDistance: z
      .enum(["0_50", "51_200", "200_plus", "nationwide_longhaul"])
      .optional(),
    corgiPassengerOperations: z.boolean().default(false),
    corgiFreightForwarder: z.boolean().default(false),
    corgiTransitMixerOperations: z.boolean().default(false),
    corgiDeliveryCourierOperations: z.boolean().default(false),
    corgiArmoredVehicles: z.boolean().default(false),
    corgiMostRunsUnder100Miles: z.boolean().default(false),
    corgiAutoRemoved: z.boolean().default(false),
    operatingStart: z
      .object({
        year: z.string().optional(),
        month: z.string().optional(),
      })
      .optional(),
    entityType: z
      .preprocess(
        (val) => (val === "" ? undefined : val),
        z.enum([
          "individual",
          "corporation",
          "llc",
          "joint_venture",
          "partnership",
        ])
      )
      .or(z.undefined())
      .refine((val) => val !== undefined, {
        message: "Please select an entity type",
      }),
    business_description: z.array(
      z.enum([
        "local_trucker",
        "intermediate",
        "long_haul_trucker",
        "intermodal_or_port",
        "household_goods_mover",
        "tankers",
        "uiia_intermodal",
        "end_dumper_units",
        "automobile_hauler",
        "refrigerated_trailer",
        "oversized_or_overweight",
        "logging",
        "hot_shot",
        "dump_truck",
        "dump_truck_sand_gravel",
      ])
    ),
    hasIneligibleOps: z.boolean().optional(),
    operationDescription: z
      .string("Description is required")
      .min(1, "Description is required"),
    noneOfMentioned: z.boolean().optional(),
  })
  .superRefine((data, ctx) => {
    const carriers = Array.isArray(data?.carrier) ? data.carrier : [];
    const hasProgressive = carriers.includes("Progressive");
    const hasCorgi = carriers.includes("Corgi Trucking");
    const operatingStartYear = `${data?.operatingStart?.year ?? ""}`.trim();
    const operatingStartMonth = `${data?.operatingStart?.month ?? ""}`.trim();
    const hasOperatingStartYear = Boolean(operatingStartYear);
    const hasOperatingStartMonth = Boolean(operatingStartMonth);
    const requiresOperatingStart = carriers.length > 0 && !hasProgressive;

    if (requiresOperatingStart || hasOperatingStartYear || hasOperatingStartMonth) {
      if (!hasOperatingStartYear) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["operatingStart", "year"],
          message: "Please select a year",
        });
      }
      if (!hasOperatingStartMonth) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["operatingStart", "month"],
          message: "Please select a month",
        });
      }
    }

    if (hasCorgi && !data.corgiTravelDistance) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["corgiTravelDistance"],
        message: "Travel Distance is required for Corgi Trucking",
      });
    }
  });
